// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YahooLogo_wrapper__jpljH","yahooLogo":"YahooLogo_yahooLogo__Q8mNl"};